export default "__VITE_ASSET__4n$UJrD$__"